var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-md-thumbs-up",
    "data-name": "Icon ionic-md-thumbs-up",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.28,
    height: 20.571,
    viewBox: "0 0 22.28 20.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a1a3ef;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_79847",
    "data-name": "Path 79847",
    className: "cls-1",
    d: "M13.286,25.071H22.5a1.966,1.966,0,0,0,1.832-1.254l3.059-7.254a2.05,2.05,0,0,0,.139-.75V13.746a2.363,2.363,0,0,0-2.025-2.389H19.12l.964-4.366.032-.321a1.553,1.553,0,0,0-.445-1.088L18.589,4.5l-6.75,6.82a2.062,2.062,0,0,0-.589,1.452V23.057A2.02,2.02,0,0,0,13.286,25.071Z",
    transform: "translate(-5.25 -4.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79848",
    "data-name": "Path 79848",
    className: "cls-1",
    d: "M3.375,15.75H6.8v12H3.375Z",
    transform: "translate(-3.375 -7.179)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbIcon);
export default __webpack_public_path__ + "static/media/Thumb Icon.8c39ce874fa9d166d4d034630beca070.svg";
export { ForwardRef as ReactComponent };